import React, {useEffect, useMemo, useState} from "react";
import {Col, Spin} from "antd";
import _ from "lodash";
import {
    CityFilter,
    IntegrationTypeFilter,
    PoolActivityFilter,
    PoolAvailableRateFilter,
    PoolSlotRateFilter
} from "../../../_defaultComponents/FilterComponents";
import {cities} from "../../../../constants/constants";
import {useCitiesForPools} from "../../../../hooks/useCitiesForPools";

const Filters = ({setCurrentPage, filters, setFilters, data = []}) => {
    const [city, setCity] = useState(filters.city);
    const [availableRate, setAvailableRate] = useState(filters.availableRate);
    const [slotRate, setSlotRate] = useState(filters.slotRate);
    const [activity, setActivity] = useState(filters.activity);
    const [integrationType, setIntegrationType] = useState(filters.integrationType);
    const {loading, cities: citiesData} = useCitiesForPools();
    const restrictedCities = useMemo(() => {
        if (!citiesData) return;
        return cities
            .filter(c => !citiesData.includes(c?.name?.toLocaleLowerCase("tr-TR")))
            .map(c => c?.name || "");
    }, [citiesData]);

    useEffect(() => {
        setCurrentPage(1);
    }, [city, availableRate, slotRate, activity, integrationType]);

    useEffect(() => {
        const newFilters = {city, availableRate, slotRate, activity, integrationType};
        if (JSON.stringify(filters) !== JSON.stringify(newFilters)) {
            setFilters(newFilters);
        }
    }, [city, availableRate, slotRate, activity, integrationType]);

    return (
        <React.Fragment>
            <Col xs={20} sm={10} md={6} lg={4} xl={3}>
                <Spin spinning={loading}>
                    <CityFilter
                        value={city}
                        onChange={setCity}
                        restrictedCities={restrictedCities}
                    />
                </Spin>
            </Col>
            <Col xs={20} sm={10} md={6} lg={4} xl={3}>
                <PoolActivityFilter value={activity} onChange={setActivity} />
            </Col>
            <Col xs={20} sm={10} md={6} lg={4} xl={3}>
                <PoolAvailableRateFilter value={availableRate} onChange={setAvailableRate} />
            </Col>
            <Col xs={20} sm={10} md={6} lg={4} xl={3}>
                <PoolSlotRateFilter value={slotRate} onChange={setSlotRate} />
            </Col>
            <Col xs={20} sm={10} md={6} lg={4} xl={3}>
                <IntegrationTypeFilter value={integrationType} onChange={setIntegrationType} />
            </Col>
        </React.Fragment>
    );
};

export default Filters;
